'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProgressBar(_ref) {
  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className;

  var style = {
    animationDuration: delay + 'ms',
    animationPlayState: isRunning ? 'running' : 'paused'
  };
  style.WebkitAnimationPlayState = style.animationPlayState;

  if (hide) {
    style.opacity = 0;
  }

  return _react2.default.createElement('div', {
    className: 'toastify__progress toastify__progress--' + type + ' ' + className,
    style: style,
    onAnimationEnd: closeToast
  });
}

ProgressBar.propTypes = {
  /**
   * The animation delay which determine when to close the toast
   */
  delay: _propTypes2.default.number.isRequired,

  /**
   * Whether or not the animation is running or paused
   */
  isRunning: _propTypes2.default.bool.isRequired,

  /**
   * Func to close the current toast
   */
  closeToast: _propTypes2.default.func.isRequired,

  /**
   * Optional type : info, success ...
   */
  type: _propTypes2.default.string,

  /**
   * Hide or not the progress bar
   */
  hide: _propTypes2.default.bool,

  /**
   * Optionnal className
   */
  className: _propTypes2.default.string
};

ProgressBar.defaultProps = {
  type: _config2.default.TYPE.DEFAULT,
  hide: false,
  className: ''
};

exports.default = ProgressBar;


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/ProgressBar.js
// module id = ./node_modules/react-toastify/lib/ProgressBar.js
// module chunks = 114276838955818 137591856104208 276150767547794